export interface PurchaseNotice {
  name: string
  city: string
  pack: string
}

const PACK_ESTANDAR = 'Pack Sin Culpa, Sin Destrozos'
const PACK_COMPLETO = 'Pack + Kit de Emergencia Total™'

export const purchases: PurchaseNotice[] = [
  { name: 'Marina G.', city: 'Rosario, Santa Fe', pack: PACK_COMPLETO },
  { name: 'Diego F.', city: 'Córdoba Capital', pack: PACK_ESTANDAR },
  { name: 'Lucía R.', city: 'La Plata, Buenos Aires', pack: PACK_COMPLETO },
  { name: 'Matías S.', city: 'Mendoza', pack: PACK_ESTANDAR },
  { name: 'Sofía B.', city: 'Mar del Plata', pack: PACK_COMPLETO },
  { name: 'Nicolás A.', city: 'San Miguel de Tucumán', pack: PACK_ESTANDAR },
  { name: 'Valentina P.', city: 'Palermo, CABA', pack: PACK_COMPLETO },
  { name: 'Julián M.', city: 'Salta', pack: PACK_COMPLETO },
  { name: 'Camila T.', city: 'Neuquén', pack: PACK_ESTANDAR },
  { name: 'Federico L.', city: 'Bahía Blanca', pack: PACK_COMPLETO },
  { name: 'Agustina C.', city: 'Santa Fe Capital', pack: PACK_ESTANDAR },
  { name: 'Ramiro D.', city: 'San Juan', pack: PACK_COMPLETO },
  { name: 'Florencia V.', city: 'Quilmes, Buenos Aires', pack: PACK_COMPLETO },
  { name: 'Ezequiel N.', city: 'Paraná, Entre Ríos', pack: PACK_ESTANDAR },
  { name: 'Brenda O.', city: 'Bariloche, Río Negro', pack: PACK_COMPLETO },
  { name: 'Hernán Q.', city: 'Corrientes', pack: PACK_ESTANDAR },
  { name: 'Micaela Z.', city: 'Posadas, Misiones', pack: PACK_COMPLETO },
  { name: 'Pablo E.', city: 'Río Cuarto, Córdoba', pack: PACK_ESTANDAR },
  { name: 'Daniela I.', city: 'Belgrano, CABA', pack: PACK_COMPLETO },
  { name: 'Gonzalo H.', city: 'Resistencia, Chaco', pack: PACK_COMPLETO },
]
